import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Compass, ArrowRight, ArrowLeft } from 'lucide-react';
import { PAGE_META } from '@/data/pageMeta';
import usePageMeta from '@/hooks/usePageMeta';
import LandingHeader from '@/components/landing/LandingHeader';
import LandingFooter from '@/components/landing/LandingFooter';
import shared from '@/styles/public.module.css';
import styles from './NotFound.module.css';


// The pages people actually land here looking for.
const POPULAR_LINKS = [
  { label: 'Common questions', to: '/faq' },
  { label: 'Apply for funding', to: '/apply' },
  { label: 'For attorneys', to: '/for-law-firms' },
  { label: 'For funders', to: '/for-funders' },
  { label: 'Log in to your account', to: '/login' },
  { label: 'Contact us', to: '/contact' },
];

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();

  usePageMeta(PAGE_META.notFound);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="not-found-page">
      <LandingHeader />

      <main>

      <section className={shared.section}>
        <div className={shared.wrap}>
          <div className={styles.inner}>
            <div className={styles.iconBox}>
              <Compass size={26} aria-hidden="true" />
            </div>

            <span className={styles.badge}>Error 404</span>

            <h1 className={styles.title}>We Could Not Find That Page</h1>

            <p className={styles.lead}>
              The page you were looking for does not exist, or it may have moved. Nothing is
              wrong with your application or your account.
            </p>

            <p className={styles.path} data-testid="not-found-path">{location.pathname}</p>

            <div className={styles.actions}>
              <button
                type="button"
                className={`${shared.btn} ${shared.btnAction}`}
                onClick={() => navigate('/apply')}
                data-testid="not-found-apply-btn"
              >
                Apply for Funding
                <ArrowRight size={18} aria-hidden="true" />
              </button>
              <button
                type="button"
                className={`${shared.btn} ${shared.btnQuiet}`}
                onClick={() => navigate('/')}
                data-testid="not-found-home-btn"
              >
                <ArrowLeft size={17} aria-hidden="true" />
                Back to Home
              </button>
            </div>

            <hr className={styles.rule} />

            <nav aria-label="Popular pages">
              <div className={shared.eyebrow}>Looking for one of these?</div>
              <div className={styles.links}>
                {POPULAR_LINKS.map((link) => (
                  <a
                    key={link.to}
                    href={link.to}
                    className={styles.link}
                    onClick={(e) => { e.preventDefault(); navigate(link.to); }}
                    data-testid={`not-found-link-${link.to.replace(/\//g, '')}`}
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </nav>
          </div>
        </div>
      </section>
      </main>


      <LandingFooter />
    </div>
  );
}
